import React from 'react';
export function ValueStackCTA({
  onBuyClick
}: {
  onBuyClick: () => void;
}) {
  return <section id="value-stack" className="py-[80px] px-5 bg-white border-t border-brand-border scroll-mt-16" data-id="element-564">
      <div className="max-w-[600px] mx-auto" data-id="element-565">
        <div className="bg-white border-2 border-brand-emerald rounded-2xl p-8 shadow-xl" data-id="element-566">
          <h2 className="text-2xl font-black text-brand-navy mb-6 text-center font-montserrat" data-id="element-567">
            Resumen de tu Orden
          </h2>

          <div className="space-y-3 mb-8" data-id="element-568">
            <div className="flex justify-between items-center border-b border-brand-border pb-3" data-id="element-569">
              <span className="text-brand-textSecondary font-medium text-sm" data-id="element-570">
                Guía Sistema 4C — 13 capítulos
              </span>
              <span className="text-brand-navy font-bold" data-id="element-571">$47.00</span>
            </div>
            <div className="flex justify-between items-center border-b border-brand-border pb-3" data-id="element-572">
              <span className="text-brand-textSecondary font-medium text-sm" data-id="element-573">
                Plan de Acción de 21 Días
              </span>
              <span className="text-brand-navy font-bold" data-id="element-574">$17.00</span>
            </div>
            <div className="flex justify-between items-center border-b border-brand-border pb-3" data-id="element-575">
              <span className="text-brand-textSecondary font-medium text-sm" data-id="element-576">
                BONO 1: Blindaje Financiero (ITIN)
              </span>
              <span className="text-brand-emerald font-bold" data-id="element-577">GRATIS</span>
            </div>
            <div className="flex justify-between items-center border-b border-brand-border pb-3" data-id="element-578">
              <span className="text-brand-textSecondary font-medium text-sm" data-id="element-579">
                BONO 2: Mapa Ruta Casa Propia
              </span>
              <span className="text-brand-emerald font-bold" data-id="element-580">GRATIS</span>
            </div>
            <div className="flex justify-between items-center border-b border-brand-border pb-3" data-id="element-581">
              <span className="text-brand-textSecondary font-medium text-sm" data-id="element-582">
                BONO 3: Salto a Dueño (LLC)
              </span>
              <span className="text-brand-emerald font-bold" data-id="element-583">GRATIS</span>
            </div>
            <div className="flex justify-between items-center pb-1" data-id="element-584">
              <span className="text-brand-textSecondary font-medium text-sm" data-id="element-585">
                Sistema de Garantía 30 días
              </span>
              <span className="text-brand-emerald font-bold" data-id="element-586">GRATIS</span>
            </div>
          </div>

          <div className="bg-brand-bg p-5 rounded-xl mb-8 text-center border border-brand-border" data-id="element-587">
            <div className="text-base text-brand-textSecondary mb-1" data-id="element-588">
              Valor Total:{' '}
              <span className="line-through font-bold" data-id="element-589">$128.00</span>
            </div>
            <div className="text-4xl font-black text-brand-emerald" data-id="element-590">$14</div>
            <div className="text-xs text-brand-textSecondary mt-1" data-id="element-591">
              Precio Especial Hoy
            </div>
          </div>

          <button onClick={onBuyClick} className="btn-buy-main block w-full text-center py-5 px-6 text-xl font-bold uppercase tracking-wide mb-4 border-none cursor-pointer" data-id="element-592">
            SÍ, DAME ACCESO INMEDIATO
          </button>

          <div className="text-center" data-id="element-593">
            <p className="text-sm text-brand-textSecondary font-medium mb-4" data-id="element-594">
              🛡️ Garantía de Satisfacción 100% por 7 días
            </p>
            <div className="flex justify-center gap-4 text-brand-textSecondary/60 text-sm" data-id="element-595">
              <span className="flex items-center gap-1" data-id="element-596">🔒 SSL Seguro</span>
              <span data-id="element-597">Visa</span>
              <span data-id="element-598">Mastercard</span>
              <span data-id="element-599">PayPal</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}